import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthData } from '@tesla/ng-auth';
import { LanguageService } from 'app/core/services/language.service';
import { AppSettings } from "../../../../app.settings";
import { Subscription } from 'rxjs';
import { onMFAEnrollmentClick } from 'app/shared/utils/utils';
@Component({
  selector: 'app-mfa-enrollment',
  templateUrl: './enrollment.component.html',
  styleUrls: ['./enrollment.component.scss']
})
export class MfaEnrollmentComponent implements OnInit, OnDestroy {
  email: string;
  language: string;
  isRedirecting: boolean;
  languageSub: Subscription;

  constructor(private authData: AuthData, private languageService: LanguageService, private configuration: AppSettings) {
    this.email = this.authData.getUserInfo().email;
    this.languageSub = this.languageService.getSelectedLanguageAsync().subscribe(res => this.language = res || "en-US")
  }

  ngOnInit(): void {
  }

  onEnroll() {
    this.isRedirecting = true;
    onMFAEnrollmentClick(this.configuration, this.authData, this.email, this.language);
  }

  ngOnDestroy(): void {
    if(this.languageSub) this.languageSub.unsubscribe();
  }
}
